// components/CallerStatsTable.js
import React from 'react';

const CallerStatsTable = ({ callers, columns }) => {
    const formatValue = (value, key) => {
        if (value === null || value === undefined) return '-';

        if (typeof value === 'number') {
            if (key.includes('percentage')) {
                return `${value.toFixed(2)}%`;
            }
            if (key.includes('market_cap') || key.includes('liquidity')) {
                return value.toLocaleString();
            }
            return value;
        }
        return value;
    };

    const getCellStyle = (key, value) => {
        const baseStyle = { ...styles.dataCell };

        if (typeof value === 'number') {
            Object.assign(baseStyle, styles.numericCell);

            if (key.includes('profit_percentage')) {
                Object.assign(baseStyle, styles.profitCell);
                if (value > 0) Object.assign(baseStyle, styles.positiveProfit);
                if (value < 0) Object.assign(baseStyle, styles.negativeProfit);
            }

            if (key.includes('loss_percentage')) {
                if (value > 0) Object.assign(baseStyle, styles.negativeProfit);
            }
        }

        if (key === 'caller_name') {
            Object.assign(baseStyle, styles.nameCell);
        }

        return baseStyle;
    };

    return (
        <div style={styles.tableContainer}>
            <table style={styles.table}>
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key} style={styles.headerCell}>
                                {column.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {callers.map((caller, index) => (
                        <tr
                            key={caller.caller_id || index}
                            style={index % 2 === 0 ? styles.evenRow : styles.oddRow}
                        >
                            {columns.map((column) => (
                                <td
                                    key={column.key}
                                    style={getCellStyle(column.key, caller[column.key])}
                                >
                                    {formatValue(caller[column.key], column.key)}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const styles = {
    container: {
        padding: '20px',
        maxWidth: '100%',
        margin: '0 auto',
        backgroundColor: '#f9fafb',
    },
    header: {
        marginBottom: '24px',
    },
    headerTitle: {
        fontSize: '24px',
        fontWeight: '600',
        color: '#111827',
        marginBottom: '8px',
    },
    searchContainer: {
        backgroundColor: '#ffffff',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        marginBottom: '20px',
        overflowX: 'auto',
    },
    searchGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: '12px',
        padding: '8px',
    },
    searchInput: {
        width: '100%',
        padding: '8px 12px',
        borderRadius: '6px',
        border: '1px solid #e5e7eb',
        fontSize: '14px',
        color: '#374151',
        backgroundColor: '#f9fafb',
        transition: 'border-color 0.2s',
        ':focus': {
            borderColor: '#3b82f6',
            outline: 'none',
        },
    },
    tableContainer: {
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        overflowX: 'auto',
    },
    table: {
        width: '100%',
        minWidth: '1100px',
        borderCollapse: 'separate',
        borderSpacing: 0,
    },
    headerCell: {
        position: 'sticky',
        top: 0,
        backgroundColor: '#f8fafc',
        color: '#374151',
        fontWeight: '600',
        padding: '14px 16px',
        textAlign: 'left',
        fontSize: '14px',
        borderBottom: '2px solid #e2e8f0',
        whiteSpace: 'nowrap',
    },
    dataCell: {
        padding: '12px 16px',
        fontSize: '14px',
        color: '#4b5563',
        borderBottom: '1px solid #e5e7eb',
        whiteSpace: 'nowrap',
    },
    numericCell: {
        textAlign: 'right',
        fontFamily: 'monospace',
    },
    nameCell: {
        color: '#2563eb',
        fontWeight: '500',
    },
    profitCell: {
        textAlign: 'right',
        fontFamily: 'monospace',
        fontWeight: '500',
    },
    positiveProfit: {
        color: '#059669',
    },
    negativeProfit: {
        color: '#dc2626',
    },
    evenRow: {
        backgroundColor: '#ffffff',
    },
    oddRow: {
        backgroundColor: '#f8fafc',
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px',
        color: '#6b7280',
        gap: '12px',
    },
    refreshInfo: {
        fontSize: '12px',
        color: '#6b7280',
        textAlign: 'right',
        marginTop: '8px',
    },
};

export default CallerStatsTable;